import React from "react";
import Slider from "react-slick";
import { HiOutlineHome } from "react-icons/hi";
import { Link } from "react-router-dom";
import advertisements from "../../data/advertisements";
import QuickPay from "./QuickPay";
import DisplayLayout from "../../components/layout/DisplayLayout";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactUsButton from "../../components/button/ContactUsButton";

const customFooter = () => {
  return (
    <div className="bg-[#D3EAF2] absolute bottom-0 z-20 left-0 py-8 px-5 ksm:rounded-t-[40px] kmd:rounded-t-[70px]  klg:rounded-t-[80px] kxl:rounded-t-[100px] w-full h-[8%] flex justify-between kmd:py-12 kmd:px-10 kxl:py-32 kxl:px-24">
      <img
        src="/logo/donation-logo.png"
        alt=""
        className="ksm:w-[195px] kmd:w-[300px] kxl:w-[400px] ksm:h-[40px] kmd:h-[80px] kxl:h-[120px] items-center"
      />
      <a href="/" className="flex gap-x-2 items-center">
        <div className="text-lg kmd:text-2xl font-bold kxl:text-3xl uppercase">
          GO TO KIOSK <br />
          HOME PAGE
        </div>
        <div className="font-bold">
          <HiOutlineHome size={50} />
        </div>
      </a>
    </div>
  );
};

const Advertise = () => {
  const settings = {
    infinite: true,
    speed: 5000,
    autoplay: true,
    fade: true,
    autoplaySpeed: 15000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="relative overflow-hidden">
      <DisplayLayout
        mainBg="#4BB1CE"
        footerBg="#D3EAF2"
        customFooter={customFooter}
      >
        <div className="bg-gradient-to-t from-white to-[#bef0ec] absolute z-10 shadow-home ksm:h-[90%] ksm:w-[90%]  overflow-hidden ksm:rounded-[15px] kmd:rounded-[25px] kxl:rounded-[40px]">
          <Slider {...settings}>
            {advertisements.map((slide) => {
              const { donation, poster, id, isContact } = slide || {};
              const { donationId, donationTitle } = donation || {};
              return (
                <div className="relative" key={id}>
                  <div
                    className="w-full h-full bg-center bg-cover bg-no-repeat"
                    style={{
                      backgroundImage: `url(${poster})`,
                    }}
                  >
                    <div className="w-full flex justify-center items-center absolute bottom-32">
                      {donationId && (
                        <Link
                          to={`/donation/${donationId}/${donationTitle}`}
                          className="ksm:px-12 kmd:px-20 kxl:px-32 ksm:py-3 kmd:py-5 kxl:py-8 ksm:text-[15px] kmd:text-30 klg:text-[48px] kxl:text-60  bg-gray-800 rounded-full text-white  border-gray-50 border-4"
                        >
                          Touch to Donate
                        </Link>
                      )}
                    </div>

                    {isContact && (
                      <div className="w-full flex justify-center items-center absolute bottom-32">
                        {" "}
                        <ContactUsButton />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
        <QuickPay />
      </DisplayLayout>
    </div>
  );
};

export default Advertise;
